module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-left-circle-fill-12ce3359.svg";